import { createSlice } from "@reduxjs/toolkit"

const VariousVariables = createSlice({
    name: "VariousVariables",
    initialState: {
        refreshTable: false,
        refreshApplicationInformation:false
    }, reducers: {
        setRefreshTable: (state) => {
            if (state.refreshTable) {
                state.refreshTable = false
            } else {
                state.refreshTable = true
            }
        },
        setrefreshApplicationInformation: (state) => {
            if (state.refreshApplicationInformation) {
                state.refreshApplicationInformation = false
            } else {
                state.refreshApplicationInformation = true
            }
        }
    }
})

export const {setRefreshTable,setrefreshApplicationInformation}=VariousVariables.actions;
export default VariousVariables.reducer;